export var CommandSource;
(function (CommandSource) {
    CommandSource["FormSubmission"] = "FormSubmission";
    CommandSource["ManualEntry"] = "ManualEntry";
    CommandSource["Import"] = "Import";
})(CommandSource || (CommandSource = {}));
export var CommandStatus;
(function (CommandStatus) {
    CommandStatus["Open"] = "open";
    CommandStatus["Submitted"] = "submitted";
    CommandStatus["Validated"] = "validated";
    CommandStatus["Complete"] = "complete";
    /** @deprecated - do not use anymore, manual command removed are fully deleted instead */
    CommandStatus["Archived"] = "archived";
    CommandStatus["Failed"] = "failed";
    CommandStatus["Expired"] = "expired";
})(CommandStatus || (CommandStatus = {}));
export var CommandLang;
(function (CommandLang) {
    CommandLang["EN"] = "EN";
    CommandLang["FR"] = "FR";
    CommandLang["ES"] = "ES";
})(CommandLang || (CommandLang = {}));
